import { Check, Circle } from "lucide-react";
import { Link } from "react-router-dom";

const scrollTo = (testid) =>
  document.querySelector(`[data-testid="${testid}"]`)?.scrollIntoView({ behavior: "smooth", block: "center" });

export default function LaunchJourney({ coin }) {
  const published = coin.status === "published" || coin.status === "featured";
  const minted = Boolean(coin.mint_address || coin.devnet_mint_address);
  const pooled = Boolean(coin.lp_pool_id);

  const steps = [
    { id: "create", label: "Created", done: true, cost: "Free — AI name, logo, whitepaper" },
    {
      id: "publish", label: "Published", done: published, cost: "$19 one-time (card)",
      action: !published && (
        <Link to="/pricing" data-testid="journey-publish-btn" className="journey-btn">Publish →</Link>
      ),
    },
    {
      id: "mint", label: "Minted on-chain", done: minted, cost: "~0.02 SOL rent + small fee (Phantom)",
      action: published && !minted && (
        <button onClick={() => scrollTo("mint-panel")} data-testid="journey-mint-btn" className="journey-btn">Mint →</button>
      ),
    },
    {
      id: "pool", label: "Liquidity pool", done: pooled, cost: "Your SOL + ~0.15 SOL Raydium fee (1% to SolSpur)",
      action: minted && !pooled && (
        <button onClick={() => scrollTo("lp-panel")} data-testid="journey-pool-btn" className="journey-btn">Create pool →</button>
      ),
    },
    {
      id: "share", label: "Shared", done: false, cost: "Free — card + referral link do the work",
      action: (
        <button onClick={() => scrollTo("share-tools")} data-testid="journey-share-btn" className="journey-btn">Share →</button>
      ),
    },
  ];
  const doneCount = steps.filter((s) => s.done).length;

  return (
    <div className="border-2 border-[#cfff04] bg-[#121212] p-6 mb-6" data-testid="launch-journey">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#cfff04]">// Launch journey</span>
        <span className="font-mono text-[11px] text-[#d0d0d0]" data-testid="journey-progress">{doneCount}/5 complete</span>
      </div>
      <div className="h-1.5 bg-[#141414] mb-5">
        <div className="h-full bg-[#cfff04] transition-all" style={{ width: `${(doneCount / 5) * 100}%` }} />
      </div>
      <div className="space-y-3">
        {steps.map((s) => (
          <div key={s.id} className="flex items-start gap-3" data-testid={`journey-step-${s.id}`}>
            {s.done ? (
              <Check size={16} className="text-[#00ff41] mt-0.5 flex-shrink-0" />
            ) : (
              <Circle size={16} className="text-[#8a8a8a] mt-0.5 flex-shrink-0" />
            )}
            <div className="flex-1 min-w-0">
              <span className={`font-display font-bold uppercase text-sm ${s.done ? "text-white" : "text-[#d0d0d0]"}`}>
                {s.label}
              </span>
              <div className="font-mono text-[11px] text-[#b8b8b8] mt-0.5">{s.cost}</div>
            </div>
            {s.action || null}
          </div>
        ))}
      </div>
    </div>
  );
}
